// extracted by mini-css-extract-plugin
module.exports = {"roundedIcon":"styles_roundedIcon__1D7PM","squareIcon":"styles_squareIcon__3PpHv"};